(ns practitest.frontend.common.websocket
  (:require
    [practitest.frontend.common.logger :as log]))

(defmulti decode-message :format)

(defmethod decode-message :json
  [{:keys [data]}]
  (js->clj (js/JSON.parse data) :keywordize-keys true))

(defmulti encode-message :format)

(defmethod encode-message :json
  [{:keys [data]}]
  (js/JSON.stringify (clj->js data)))

(defn make-ws [{:keys [url format on-open on-message on-error on-close]}]
  (log/debug "[WEBSOCKET]: connecting to " url)
  (let [ws (js/WebSocket. url)]
    (set! (.-onopen ws)
      (fn [_]
        (when on-open
          (on-open))))
    (set! (.-onmessage ws)
      (fn [event]
        (when on-message
          (on-message
            (decode-message
              {:format format
               :data   (.-data event)})))))
    (set! (.-onerror ws)
      (fn [error]
        (when on-error
          (on-error error))))
    (set! (.-onclose ws)
      (fn [event]
        (when on-close
          (on-close (.-code event) (.-reason event)))))
    {:conn   ws
     :format format}))

(defn destroy-ws [{:keys [conn]}]
  (when conn
    (.close conn 1000)))

(defn send-message [{:keys [conn format]} data]
  (try
    (when (= (.-readyState conn) 1)
      (.send conn
             (encode-message
              {:format format
               :data   data})))
    (catch js/Error e
      (log/warn "Caught exception: " (.-message e)))))
